import {Document} from '../document';
import {AbstractBilling} from './abstract-billing';

export class Invoice extends AbstractBilling {
  reference: string | null = null;
  status: string = 'waiting_for_approval';
  invoiceFile: Document | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.invoiceFile) {
      this.invoiceFile = new Document().deserialize(input.invoiceFile);
    }

    return this;
  }

  getStatusClass(): string {
    switch (this.status) {
      case 'invoice_validated':
        return 'bg-primary';
      case 'payment_in_progress':
        return 'bg-secondary';
      case 'paid':
        return 'bg-success';
      default:
        return 'bg-info';
    }
  }

  isWaitingForApproval(): boolean {
    return this.status === 'waiting_for_approval';
  }

  isValidated(): boolean {
    return this.status === 'invoice_validated';
  }

  isAccounted(): boolean {
    return this.status === 'payment_in_progress';
  }

  isPaid(): boolean {
    return this.status === 'paid';
  }
}
